import {
  type TagConstructor,
  type TagForTable,
} from "#customTypes/composedTypes/tagTypes"
import { type Uuid } from "#customTypes/globalTypes"

export class Tag {
  id: Uuid
  label: string
  icon: string
  description?: string

  constructor(props: TagConstructor) {
    this.id = props.id
    this.label = props.label
    this.icon = props.icon
    this.description = props.description
  }

  getTagForTable = (): TagForTable => ({
    id: this.id,
    label: this.label,
    icon: this.icon,
  })
}
